export default {
  SET_BEST_SELLING: "SET_BEST_SELLING",
  SET_HOT_SELLING: "SET_HOT_SELLING",
  SET_NEW_LAUNCHING: "SET_NEW_LAUNCHING",
  SET_HEADER_RIBBON: "SET_HEADER_RIBBON",
  SET_SALE_BANNER: "SET_SALE_BANNER",
  SET_BANNERS: "SET_BANNERS",
}